import styled from '@emotion/styled'
import { ReactNode, useState } from 'react'
import { L1ClipboardCopyButton, useClipboardCopy } from '../../../interface/L1ClipboardCopyButton'
import { shortGuid } from '@fusion-advantage/formlib'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface V2L2WorkItemDetailContentItemRootProps {
	span?: number
}

const V2L2WorkItemDetailContentItemRoot = styled.div<V2L2WorkItemDetailContentItemRootProps>(({span = 1}) => ({
	display: 'flex',
	flexDirection: 'column',
	gridColumn: `span ${span}`,
}))

const V2L2WorkItemDetailContentItemLabel = styled.div(({theme}) => ({
	color: theme.colors.inputLabel,
	marginBottom: '2px',
}))

const V2L2WorkItemDetailContentItemValue = styled.div(({theme}) => ({
	fontWeight: 600,
}))

const V2L2WorkItemDetailContentItemValueIcon = styled(FontAwesomeIcon)({
	marginRight: '.5rem',
})

interface V2L2WorkItemDetailContentItemProps {
	span?: number
	label?: string
	icon?: IconProp
	children?: ReactNode
}

export const V2L2WorkItemDetailContentItem = ({span, label, icon, children}: V2L2WorkItemDetailContentItemProps) => {
	return (
		<V2L2WorkItemDetailContentItemRoot span={span}>
			<V2L2WorkItemDetailContentItemLabel>{label ?? `\u00A0`}</V2L2WorkItemDetailContentItemLabel>
			<V2L2WorkItemDetailContentItemValue>
				{icon ? <V2L2WorkItemDetailContentItemValueIcon icon={icon} /> : null}
				{children ?? `\u00A0`}
			</V2L2WorkItemDetailContentItemValue>
		</V2L2WorkItemDetailContentItemRoot>
	)
}

const GuidLabel = styled.label({
	marginRight: '.5rem',
	cursor: 'pointer',
})

interface V2L2WorkItemDetailGuidContentItemProps {
	span?: number
	label?: string
	value: string
}

export const V2L2WorkItemDetailGuidContentItem = ({span, label, value}: V2L2WorkItemDetailGuidContentItemProps) => {
	const [shorten, setShorten] = useState(true)
	const { showSuccess, handleClick } = useClipboardCopy(value)
	return (
		<V2L2WorkItemDetailContentItem span={span} label={label}>
			<GuidLabel onClick={() => setShorten(false)}>
				{shorten ? shortGuid(value) + '⋯' : value}
			</GuidLabel>
			<L1ClipboardCopyButton
				showSuccess={showSuccess}
				onClick={handleClick}
			/>
		</V2L2WorkItemDetailContentItem>
	)
}
